class LandingPage extends HTMLElement {
  constructor() {
    super();
    this.hasRendered = false;

    this.ethos = [
      { title: 'Radical Friend Privacy', copy: 'Your posts stop with your friends. No feeds, no FOMO roulette, no growth hacks.' },
      { title: 'Intentional Mischief', copy: 'Events, prompts, GIF duels, and mood music that reward the people who actually show up.' },
      { title: 'Kindness Guardrails', copy: 'Audit logs, human review, and friend-of-friend invitations only.' }
    ];

    this.checklist = [
      { title: 'You remember AIM away messages', copy: 'and maybe still have your favorite CSS glitter text saved somewhere.' },
      { title: 'You send playlists at 2 AM', copy: 'because vulnerability tastes better with a lo-fi beat drop.' },
      { title: 'You want fewer algorithms', copy: 'and more tiny celebrations from the 6 people who actually know you.' },
      { title: 'You treat safety seriously', copy: 'and want a team obsessed with monitoring before monetizing.' },
      { title: 'You spin the writing prompt washing machine', copy: 'and let it spit out delightful chaos when your brain needs a nudge.' }
    ];

    this.carousel = [
      { label: 'Posts', title: 'Moody Monday Zines', copy: 'Friends build collaborative zines with scanned doodles and shared photos.' },
      { label: 'Events', title: 'Midnight Snack Club', copy: 'Recurring invite where everyone shares weird recipes + polls the raccoon.' },
      { label: 'Prompts', title: 'Washing Machine Inspiration', copy: 'Push the big button, get a random writing prompt, then share it with friends.' }
    ];

    this.funFacts = [
      'Your posts could include handmade doodles or polaroids.',
      'The prompt washing machine keeps generating weird ideas and you can add to them.',
      'You can create your bi-weekly game night and keep folks up to date.',
      'Share those jams you\'re currently vibing to.'
    ];

    this.factIndex = 0;
  }

  connectedCallback() {
    if (this.hasRendered) return;
    this.render();
    this.startFunFactTicker();
    this.hasRendered = true;
  }

  disconnectedCallback() {
    if (this.tickerInterval) {
      clearInterval(this.tickerInterval);
    }
  }

  render() {
    this.innerHTML = `
      <section class="landing-page" aria-label="Fun Old Times public welcome">
        ${this.renderHero()}
        ${this.renderEthos()}
        ${this.renderChecklist()}
        ${this.renderCarousel()}
        ${this.renderSecondaryCTA()}
      </section>
    `;

    this.bindCTAButtons();
  }

  renderHero() {
    return `
      <div class="landing-hero">
        <div>
          <p class="landing-hero__eyebrow">Friends first • Weird always</p>
          <h1 class="landing-hero__title">
            A cozy internet clubhouse where <span>only your friends</span> see your best chaos.
          </h1>
          <p class="landing-hero__copy">
            No algorithms. No infinite scroll. Just bright colors, silly prompts, and the six people who still laugh at your AIM away messages.
          </p>
          <div class="landing-hero__cta" role="group" aria-label="Get started">
            <button class="primary" data-auth-mode="register" data-surface="hero_primary">Sign up free</button>
            <button class="secondary" data-auth-mode="login" data-surface="hero_secondary">Already a member? Log in</button>
          </div>
          <div class="landing-ticker" aria-live="polite">
            <span>✨</span>
            <p id="landingFact">Fun fact loading…</p>
          </div>
        </div>
      </div>
    `;
  }

  renderEthos() {
    return `
      <section class="landing-ethos" aria-label="Platform ethos promises">
        ${this.ethos.map(item => `
          <article class="landing-ethos__card">
            <h3>${item.title}</h3>
            <p>${item.copy}</p>
          </article>
        `).join('')}
      </section>
    `;
  }

  renderChecklist() {
    return `
      <section class="landing-checklist" aria-label="Is this your vibe checklist">
        <h2>Is this your vibe?</h2>
        <div class="landing-checklist__items">
          ${this.checklist.map(item => `
            <article class="landing-checklist__item">
              <span aria-hidden="true">💖</span>
              <div>
                <strong>${item.title}</strong>
                <p>${item.copy}</p>
              </div>
            </article>
          `).join('')}
        </div>
      </section>
    `;
  }

  renderCarousel() {
    return `
      <section class="landing-carousel" aria-label="Peeks at the community">
        <h2>Here’s what you could be building inside</h2>
        <div class="landing-carousel__items">
          ${this.carousel.map(item => `
            <article class="landing-carousel__card">
              <span>${item.label}</span>
              <h4>${item.title}</h4>
              <p>${item.copy}</p>
            </article>
          `).join('')}
        </div>
      </section>
    `;
  }

  renderSecondaryCTA() {
    return `
      <section class="landing-secondary-cta" aria-label="Ready to jump in">
        <button data-auth-mode="register" data-surface="secondary_primary">Start a cozy profile</button>
      </section>
    `;
  }

  bindCTAButtons() {
    const buttons = this.querySelectorAll('[data-auth-mode]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.dataset.authMode || 'login';
        const surface = button.dataset.surface || 'landing';
        this.handleAuthRequest(mode, surface);
      });
    });
  }

  handleAuthRequest(mode, surface) {
    try {
      if (window.logger?.ui) {
        window.logger.ui('landing_cta_click', 'landing-page', { mode, surface });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Landing CTA logging failed', error);
    }

    this.dispatchEvent(new CustomEvent('landing-auth-request', {
      bubbles: true,
      composed: true,
      detail: { mode }
    }));
  }

  startFunFactTicker() {
    const factEl = this.querySelector('#landingFact');
    if (!factEl) return;

    const updateFact = () => {
      factEl.textContent = this.funFacts[this.factIndex];
      this.factIndex = (this.factIndex + 1) % this.funFacts.length;
    };

    updateFact();
    this.tickerInterval = window.setInterval(updateFact, 6000);
  }
}

customElements.define('landing-page', LandingPage);

